import { useState } from "react";

export const useToggle = (initial: boolean): [boolean, () => void] => {
  const [value, set] = useState(initial);
  return [
    value,
    () => {
      set((v) => !v);
    },
  ];
};
